/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/**
 * Quick add-to-cart helpers (collection grid + cart drawer upsell).
 *
 * Both dispatch the theme's own `product:added` event. The theme's cart section listens for it, updates the
 * header count/dot, re-renders the drawer and opens it, so no cart-update logic is duplicated here.
 */
function quickAddToCart(event, variantId, button) {
  event.stopPropagation();
  event.preventDefault();

  if (!variantId || (button && button.classList.contains('is-loading'))) {
    return;
  }

  if (button) {
    button.classList.add('is-loading');
  }

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
    body: JSON.stringify({id: variantId, quantity: 1})
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Add to cart failed (' + response.status + ')');
      }

      return response.json();
    })
    .then(function () {
      if (document.getElementById('sidebar-cart')) {
        document.dispatchEvent(new CustomEvent('product:added', {bubbles: true, detail: {quantity: 1}}));
      } else {
        // Cart page mode: no drawer, so just refresh the header count.
        return fetch('/cart.js', {credentials: 'same-origin'})
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            document.querySelectorAll('.Header__CartCount').forEach(function (el) { el.textContent = cart.item_count; });
            document.querySelectorAll('.Header__CartDot').forEach(function (el) { el.classList.add('is-visible'); });
          });
      }
    })
    .catch(function (error) {
      console.error(error);
    })
    .then(function () {
      if (button) {
        button.classList.remove('is-loading');
      }
    });
}

function addItemToCart(event, vid) {
  quickAddToCart(event, vid, event.currentTarget);
}

function addItemToCartUpsell(event, vid) {
  quickAddToCart(event, vid, event.currentTarget);
}
